import React from "react";

export default function Footer(){
    return(
        <div>
            <footer>
            This project was coded by <a href='https://github.com/MadameAmaka' target='_blank' rel="noreferrer"> Amaka Onwuli </a> and is open-sourced <a href='https://github.com/MadameAmaka/react_weather_project' target='_blank' rel="noreferrer" > on Github,
            </a> and hosted on <a href='https://amakas-react-weather-app.netlify.app/' target='_blank' rel="noreferrer"> Netlify. </a>
            </footer>
        </div>
    );
}